import { render, staticRenderFns } from "./_Instrucao.vue?vue&type=template&id=4c70d0f8&scoped=true&"
import script from "./_Instrucao.vue?vue&type=script&lang=js&"
export * from "./_Instrucao.vue?vue&type=script&lang=js&"
import style0 from "./_Instrucao.vue?vue&type=style&index=0&id=4c70d0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70d0f8",
  null
  
)

export default component.exports